import React from 'react';
import { graphql, PageProps } from 'gatsby';
import Layout from 'src/elements/layout/layout';
import { TemplateContent, LegalContainer } from './legalArticle.styles';
import calculateEstimatedReadingTime from 'src/functions/calculateEstimatedReadingTime';
import { formatElementFromHtmlAst } from 'src/functions/formatElement.htmlAst';
import Heading from 'elements/typography/heading'

interface MarkupValue {
  type: 'text';
  value: string;
}

interface MarkupElement {
  type: 'element';
  tagName: 'a' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'strong' | 'ul' | 'ol' | 'li' | 'img';
  properties: {
    href?: string;
    src?: string;
  }
  children: (MarkupElement | MarkupValue)[]
}


interface LegalArticleProps extends PageProps {
  data: {
    contentfulLegalArticle: {
      id: string;
      label: string;
      slug: string;
      seoTitle: string;
      seoDescription: string;
      lastUpdated: string;
      body: {
        internal: { type: string }
        childMarkdownRemark: {
          wordCount?: {
            words?: number
          }
          htmlAst: {
            type: string;
            children: MarkupElement[]
          }
        }
      }
    }
  }
}

const LegalArticleTemplate = (props: LegalArticleProps): JSX.Element => {
  const articleData = props.data.contentfulLegalArticle;

  return (
    <Layout
      helmet={{
        title: articleData.seoTitle ?? articleData.label,
        description: articleData.seoDescription ?? '',
        estimatedReadingTime: calculateEstimatedReadingTime(articleData.body.childMarkdownRemark?.wordCount?.words)
      }}
      location={props.location}
    >
      <LegalContainer>
        <Heading
          text={articleData.label}
          align="center"
          size="3.45em"
          sizeSm="1.875em"
        />
        <br />
        {!!articleData.lastUpdated && (
          <Heading
            text={`Last updated: ${articleData.lastUpdated}`}
            align="center"
            weight="light"
            size=".75em"
          />
        )}
        <br />
        <br />
        <TemplateContent>
          {articleData.body.childMarkdownRemark.htmlAst.children.map((child, index) => formatElementFromHtmlAst(child, `${index}`, null, 'legalArticle'))}
        </TemplateContent>
      </LegalContainer>
    </Layout>
  )
}


export default LegalArticleTemplate

export const pageQuery = graphql`
  query LegalArticleBySlug($slug: String!) {
    contentfulLegalArticle(slug: { eq: $slug }) {
      id
      slug
      label
      seoTitle
      seoDescription
      lastUpdated(formatString: "MMMM DD, YYYY")
      body  {
        internal {
          type
        }
        childMarkdownRemark {
          htmlAst
          wordCount {
            words
          }
        }
      }
    }
  }
`
